<template>
  <div :class="classList">
    <i-switch :value="value"
              :loading="loading"
              :trueValue="trueValue"
              :beforeChange="beforeChange"
              @on-change="handleChange"
              :falseValue="falseValue"></i-switch>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    trueValue: {
      type: [Boolean, String, Number],
      default: true,
    },
    falseValue: {
      type: [Boolean, String, Number],
      default: false,
    },
    beforeChange: Function,
    themeColor: String,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classList() {
      return ['v-switch', this.themeColor];
    },
  },
  methods: {
    handleChange() {
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="less">
  .v-switch{
    &.primary{
      .ivu-switch{
        background-color: rgba(124, 77, 255, .5);
        &:after{
          background-color: @primary-color;
        }
      }
    }
    &.disabled{
      .ivu-switch{
        background-color: rgb(190, 193, 194, .5);
        &:after {
          background-color: rgb(117, 117, 117);
        }
      }
    }
    .ivu-switch{
      width: 34px;
      height: 14px;
      background-color: rgba(255, 255, 255, .5);
      border: none;
      &:before{
        top: 0;
        left: 0;
        border-color: transparent transparent transparent #fff;
      }
      &:after{
        left: -3px;
        top: -3px;
        box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.24);
        width: 20px;
        height: 20px;
      }
      &:focus{
        box-shadow: none;
      }
    }
    .ivu-switch-checked:after{
      left: 17px;
    }
    .ivu-switch-checked:before{
      left: 20px;
      border-color: transparent transparent transparent @primary-color;
    }
  }
</style>
